import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import MarvelLink from '@marvelapp/marvel-ui/link';

export default function FormErrorLink({
  isExternal,
  url,
  children,
  ...otherProps
}) {
  const props = {
    type: 'opaqueReversed',
    hasUnderline: true,
    ...otherProps,
  };
  return isExternal ? (
    <MarvelLink url={url} target="_blank" {...props}>
      {children}
    </MarvelLink>
  ) : (
    <Link to={url}>
      <MarvelLink {...props}>{children}</MarvelLink>
    </Link>
  );
}

FormErrorLink.propTypes = {
  isExternal: PropTypes.bool,
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/FormErrorLink/index.js